import React from 'react';
import { Input } from './Input';

export function Filter({ value, onChange, placeholder = 'Search cars...' }) {
  return (
    <div className="mb-4">
      <Input
        name="filter"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="max-w-sm"
      />
    </div>
  );
}
